// src/pages/CoursePlacesPage.jsx
import React, { useEffect, useState } from "react";
import CoursesLayout from "../components/CoursesLayout.jsx";
import "../styles/course-places.css"; // 전용 CSS

// 구글맵 임베드 URL
const mapEmbed = (q) =>
  `https://www.google.com/maps?q=${encodeURIComponent(q)}&output=embed`;

export default function CoursePlacesPage({ data: outerData }) {
  const [innerData, setInnerData] = useState(null);
  const data = outerData || innerData;

  useEffect(() => {
    if (outerData) return;
    (async () => {
      try {
        const res = await fetch("/content.json", { cache: "no-cache" });
        const json = await res.json();
        setInnerData(json);
      } catch (e) {
        console.error(e);
      }
    })();
  }, [outerData]);

  if (!data) return null;

  // ✅ 핀 이미지 경로 (전역 icons.pin, 코스 전용 courses.places.pin 모두 지원)
  const globalPin = data?.icons?.pin;
  const localPin = data?.courses?.places?.pin;
  const pinSrc = localPin || globalPin || null;

  // 데이터 (content.json 없으면 fallback)
  const places =
    data?.courses?.places?.items || [
      {
        name: "시흥 파라다이브",
        addr: "경기도 시흥시 거북섬중앙로 1",
        tel: "031-497-3133",
        mapQuery: "시흥 파라다이브",
      },
      {
        name: "성남 아쿠아라인",
        addr: "경기 성남시 분당구 정자일로 60",
        tel: "031-759-3111",
        mapQuery: "성남 아쿠아라인 수영장",
      },
      {
        name: "잠실종합운동장 내 제2수영장",
        addr: "서울 송파구 올림픽로 25",
        tel: "02-420-1114",
        mapQuery: "잠실 종합운동장 제2수영장",
      },
      {
        name: "올림픽공원 내 올림픽수영장",
        addr: "서울 송파구 올림픽로 424",
        tel: "02-410-1114",
        mapQuery: "올림픽공원 올림픽수영장",
      },
      {
        name: "수원월드컵스킨스쿠바다이빙풀",
        addr: "수원시 팔달구 평동로 210번길 41",
        tel: "0507-1397-2154",
        mapQuery: "수원월드컵스킨스쿠바다이빙풀",
      },
      {
        name: "송도스포츠파크 잠수풀",
        addr: "인천 연수구 인천타워대로 289번길 40",
        tel: "032-899-4864",
        mapQuery: "송도스포츠파크 잠수풀",
      },
      {
        name: "오산 TSN(테마스포츠네트워크)",
        addr: "경기 오산시 청학로286 테마스포츠네트워크 TSN",
        tel: "031-375-8029",
        mapQuery: "오산 TSN(테마스포츠네트워크)",
      },
      {
        name: "용인 딥스테이션",
        addr: "경기도 용인시 처인구 포곡읍 성산로 523",
        tel: "1544-9766",
        mapQuery: "용인 딥스테이션",
      }
    ];

  return (
    <div className="course-places-page">
      {/* ✅ 히어로는 CoursesLayout(SubLayout)에서 렌더됨 */}
      <CoursesLayout data={data}>
        <section className="cp-section">
          <div className="cp-container">
            <header className="cp-header">
              <h2>강습 장소</h2>
              <p>다이빙이지와 함께 강습하실 곳을 안내해 드립니다.</p>
            </header>

            <div className="cp-grid">
              {places.map((p, i) => (
                <article className="cp-card" key={i}>
                  <div className="cp-head">
                    <h3 className="cp-title">
                      <span className="cp-pin" aria-hidden="true">
                        {pinSrc ? (
                          <img
                            src={pinSrc}
                            alt=""
                            className="cp-pin-img"
                            loading="lazy"
                            width="18"
                            height="18"
                          />
                        ) : (
                          "📍"
                        )}
                      </span>
                      {p.name}
                    </h3>
                    <div className="cp-sub">
                      <div>{p.addr}</div>
                      {p.tel && <div>{p.tel}</div>}
                    </div>
                  </div>

                  <div className="cp-map">
                    <iframe
                      title={`${p.name} 지도`}
                      src={mapEmbed(p.mapQuery || p.addr)}
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      allowFullScreen
                    />
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      </CoursesLayout>
    </div>
  );
}
